/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  $(document).on("click", ".scroll-to", function(e) {
      var href = $(this).attr("href");
      var offsetTop = href === "#" ? 0 : $(href).offset().top;
      var HdTop = $(".site-header").outerHeight();
      $("html, body").stop().animate({
          scrollTop: offsetTop - HdTop
      }, 500);
      e.preventDefault();
    });
  $(document).on('click', '.nav-toggle', function(){
      $(this).toggleClass('on');
      $('html').toggleClass('nav-on');
    });
  $(document).on('click', '.mobile-navigation nav ul li.menu-item-has-children > a', function(e){
    e.preventDefault();
    $('.nav-toggle').next().slideToggle();
    $(this).toggleClass('open');
  });
  $(document).on('click', '.mobile-navigation .btn-style a', function(e){
    e.preventDefault();
     $(this).removeClass('on');
      $('html').removeClass('nav-on');
  });
  
  
   function appHeight() {
      var wh = $(window).innerHeight();
      document.documentElement.style
        .setProperty('--app-height', wh + 'px');

    }
    window.addEventListener('resize', appHeight)
    appHeight();

    $(function () {
      AOS.init({
          easing: 'ease-in-out-sine',
          duration: 400,
          once: true
      });
    });
    $(document).on('click', '.home-steps-item', function(e){
      var image = $(this).data('image');
      $('.home-steps-item').removeClass('active');
      $('.home-steps-item p, .home-steps-item .count-no').slideUp();
      $('.home-steps-image').removeClass('active');
      $(this).addClass('active');
      $(this).find('p, .count-no').slideDown();
      $(image).addClass('active');
    });

    
     $('.explore-clubs-list, .success-block-list, .content-images-block-list').slick({
      dots: false,
      infinite: true,
      arrows: true, 
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<span class="slick-arrow slick-next"><svg fill="none" width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M7.57333 1L15.6667 9.09333L7.57333 17.1867M1 9.09333H15.44"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg fill="none" width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M9.42667 1L1.33333 9.09333L9.42667 17.1867M16 9.09333H1.56"/></svg></span>',
    });
     $('.cards-cl').slick({
      dots: false,
      infinite: true,
      arrows: true, 
      slidesToShow: 2,
      slidesToScroll: 2,
      nextArrow: '<span class="slick-arrow slick-next"><svg fill="none" width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M7.57333 1L15.6667 9.09333L7.57333 17.1867M1 9.09333H15.44"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg fill="none" width="17" height="18" viewBox="0 0 17 18" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><path xmlns="http://www.w3.org/2000/svg" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M9.42667 1L1.33333 9.09333L9.42667 17.1867M16 9.09333H1.56"/></svg></span>',
       responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
     
    $('.parallax-window').jarallax();
    $(document).on('click', '.tab-list a', function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      $('.tab-list a').removeClass('active');
      $(this).addClass('active');
      $('.tab-item').removeClass('active');
      $(href).addClass('active');
      $('.cards-cl').slick('setPosition');
    });

    $('.wp-block-gallery a, .gal-item').magnificPopup({
        type: 'image',
        mainClass: 'mfp-with-zoom', 
        gallery:{
        enabled:true
      },

        zoom: {
          enabled: true, 

          duration: 300, // duration of the effect, in milliseconds
          easing: 'ease-in-out', // CSS transition easing function

          opener: function(openerElement) {

          return openerElement.is('img') ? openerElement : openerElement.find('img');
          }
       }

    });

    $('.modal-tgr, a[href="#join-now"]').magnificPopup({
      type:'inline',
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
    $(window).on('scroll', function(){
      var ST = $(this).scrollTop();
      var BH = $('.banner').outerHeight();
      if($('.sticky-nav').length){
        var OT = $('.sticky-nav').offset().top;
        if(ST >= OT){
          $('.sticky-nav-in').addClass('floating');
        }else{
          $('.sticky-nav-in').removeClass('floating');
        }
      }
    });
    if($('.sticky-nav').length){
      var lastId,
      topMenu = $(".sticky-nav-in"),
      topMenuHeight = topMenu.outerHeight()+15,
      menuItems = topMenu.find("a"),
      scrollItemsM = menuItems.map(function(){
        var item = $($(this).attr("href"));
        if (item.length) { return item; }
      });

      menuItems.click(function(e){
        var href = $(this).attr("href"),
            offsetTop = href === "#" ? 0 : $(href).offset().top;
        $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 300);
        e.preventDefault();
      });

      $(window).scroll(function(){
         var fromTop = $(this).scrollTop()+topMenuHeight;
         
         var cur = scrollItemsM.map(function(){
           if ($(this).offset().top < fromTop)
             return this;
         });
         cur = cur[cur.length-1];
         var id = cur && cur.length ? cur[0].id : "";
         if (lastId !== id) {
             lastId = id;
             menuItems.parent().removeClass("active").end().filter("[href='#"+id+"']").parent().addClass("active");
         }                   
      });
    }
    if($('.hs-scroll').length){
      var windowWidth = $(window).outerWidth();
      var windowHeight = $(window).outerHeight();
      var $root = $('html, body');



      var scrollItems = $('.hs-scroll-in');
      var scrollWidth = scrollItems.outerWidth() * scrollItems.length;
      var scrollDuration = scrollItems.outerWidth() * scrollItems.length;


      var controller = new ScrollMagic.Controller();
      var tween = TweenMax.fromTo(".hs-scroll", 1, { x: 0, y: 0, ease:Linear.easeNone }, { x: -Math.abs(windowWidth - scrollWidth), y: 0, ease:Linear.easeNone });
      var scene = new ScrollMagic.Scene({ triggerElement: ".hs-scroll", triggerHook:0, duration: scrollDuration, offset: -58})
          .setTween(tween)
          .setPin(".hs-scroll")
          .addTo(controller);
        }


});